import { render, staticRenderFns } from "./TiersArchivedListe.vue?vue&type=template&id=486c7ce4&"
import script from "./TiersArchivedListe.vue?vue&type=script&lang=js&"
export * from "./TiersArchivedListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports